import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { WidgetInternalProps } from '../../types/WidgetProps';
import { DH } from '../../utils/dataHooks';
import { WidgetRootResources } from './root-resources';

const generateUniqueDH = () => `express-checkout-widget-${Math.random().toString(36).substr(2, 9)}`;

export const RootWrapper: React.FC<WidgetInternalProps> = (props) => {
  const [widgetRootWrapperDh] = React.useState(generateUniqueDH());

  return (
    <div data-hook={widgetRootWrapperDh}>
      <ErrorBoundary fallback={<span data-hook={DH.Widget.ErrorBoundaryFallback} />}>
        <WidgetRootResources {...props} widgetRootWrapperDh={widgetRootWrapperDh} />
      </ErrorBoundary>
    </div>
  );
};
RootWrapper.displayName = 'RootWrapper';
